module.exports = __webpack_public_path__ + "img/folder.b78d661d.svg";